import * as actionTypes from './actionTypes';
import { rucService } from './services';
import { actionsModalError } from '@app/src/common/modalError';
import { TypeProfileModel } from '@app/src/views/StepPayment/formPayment/models/TypeProfileModel';
import { sendDataPayment} from '@app/src/views/StepPayment/formPayment';
import { fetchValidate } from '@app/src/common/session';

const fetchRucRequest = () => ({
  type: actionTypes.FETCH_RUC_REQUEST
});

const fetchRucFailure = () => ({
  type: actionTypes.FETCH_RUC_FAILURE
});

export const fetchRucSuccess = (data: TypeProfileModel) => ({
  type: actionTypes.FETCH_RUC_SUCCESS,
  data
});

const createRucRequest = () => ({
  type: actionTypes.CREATE_RUC_REQUEST
});

const createRucFailure = () => ({
  type: actionTypes.CREATE_RUC_FAILURE
});

export const createRucSuccess = (data: TypeProfileModel) => ({
  type: actionTypes.CREATE_RUC_SUCCESS,
  data
});

const updateRucRequest = () => ({
  type: actionTypes.UPDATE_RUC_REQUEST
});

const updateRucFailure = () => ({
  type: actionTypes.UPDATE_RUC_FAILURE
});

export const updateRucSuccess = (data: TypeProfileModel) => ({
  type: actionTypes.UPDATE_RUC_SUCCESS,
  data
});

export const setDisabledRucInputs = (isDisabled: boolean) => ({
  type: actionTypes.SET_DISABLED_RUC_INPUTS,
  isDisabled
});

export const clearRucData = () => ({
  type: actionTypes.CLEAR_RUC_DATA
})

export const fetchRuc = (documentNumber: number) => {
  return async dispatch => {
    dispatch(fetchRucRequest());
    await dispatch(fetchValidate());
    try {
      const data = await rucService.get(documentNumber);
      dispatch(fetchRucSuccess(data));
    } catch(error) {
      dispatch(actionsModalError.openModalError());
      dispatch(fetchRucFailure());
    }
  }
}

export const createRucData = (json, paymentData, price, setIsShowModal) => {
  return async dispatch => {
    dispatch(createRucRequest());
    await dispatch(fetchValidate());
    try {
      const data = await rucService.post(json);
      dispatch(createRucSuccess(data));
      dispatch(sendDataPayment({
        ...paymentData,
        customer: data.id
      }, price, setIsShowModal));
    } catch (error) {
      dispatch(actionsModalError.openModalError());
      dispatch(createRucFailure());
    }
  }
}

export const updateRucData = (json, documentNumber: number, paymentData, price, setIsShowModal) => {
  return async dispatch => {
    dispatch(updateRucRequest());
    await dispatch(fetchValidate());
    try {
      const data = await rucService.put(json, documentNumber);
      dispatch(updateRucSuccess(data));
      dispatch(sendDataPayment({
        ...paymentData,
        customer: data.id
      }, price, setIsShowModal));
    } catch (error) {
      dispatch(actionsModalError.openModalError());
      dispatch(updateRucFailure());
    }
  }
}
